<template>
  <li class="ak-basic-tree-item-wrap">
    <div class="ak-basic-tree-item" @click.stop.prevent="clickTreeItem(data)">
      <toggle-children v-model="showChildren" :show="showToggle" />
      <div style="display: flex; align-items: center">
        <slot :item="data" />
      </div>
    </div>
    <ul :class="childTreeClasses">
      <ak-tree-item
        v-for="(child, childIndex) in children"
        :key="childIndex"
        :data="child.data"
        :children="child.children"
        :show-empty="showEmpty"
      >
        <template #default="{ item }">
          <slot :item="item" />
        </template>
        <template #empty>
          <slot name="empty" />
        </template>
      </ak-tree-item>
      <li>
        <div
          class="ak-basic-tree-item"
          @click.stop.prevent="clickEmptyTreeItem(data)"
        >
          <toggle-children :show="false" />
          <slot name="empty"> Empty </slot>
        </div>
      </li>
    </ul>
  </li>
</template>

<script>
import { defineComponent, computed, ref, inject } from 'vue'
import ToggleChildren from './ToggleChildren.vue'
export default defineComponent({
  name: 'AkTreeItem',
  components: {
    [ToggleChildren.name]: ToggleChildren,
  },
  props: {
    /**
     * @type {Object}
     * @description The tree item data
     */
    data: {
      type: Object,
      default: () => ({}),
    },
    /**
     * @type {Array}
     * @description the children on the tree item
     */
    children: {
      type: Array,
      default: () => [],
    },
    /**
     * @type {Boolean}
     * @description Show show empty tree items
     */
    showEmpty: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const showChildren = ref(false)
    const clickTreeItem = inject('clickTreeItem')
    const clickEmptyTreeItem = inject('clickEmptyTreeItem')
    const checkTree = inject('isTree')
    const isTree = checkTree(props.data)

    /**
     * @type {Boolean}
     * @description Should the open an close tree button show
     */
    const showToggle = computed(() => {
      if (!isTree) return false
      if (props.showEmpty) return true
      if (props.children.length > 0) return true
      return false
    })

    /**
     * @type {Object}
     * @description css classes for hiding and showing sub tree
     */
    const childTreeClasses = computed(() => {
      return {
        'ak-basic-tree-item__child-tree': true,
        'ak-basic-tree-item__child-tree-hidden': !showChildren.value,
        bl: true,
      }
    })

    return {
      showChildren,
      showToggle,
      childTreeClasses,
      clickTreeItem,
      clickEmptyTreeItem,
    }
  },
})
</script>

<style lang="scss">
@import '../../scss/_settings.scss';
.ak-basic-tree-item-wrap {
  display: flex;
  flex-direction: column;
  margin-top: $spacing-tiny;
  margin-bottom: $spacing-tiny;
  .ak-basic-tree-item {
    display: flex;
    align-items: center;
    padding: $spacing-small $spacing-tiny;
    border-radius: 5px;
    line-height: 1.2;
    cursor: pointer;
    &:hover {
      background-color: $color-grey-lighter;
    }
    &__child-tree {
      margin-left: $spacing-small;
      max-height: calc(100vh - 50px);
      overflow-y: hidden;
      transition: max-height 0.5s ease-in-out;
      &-hidden {
        max-height: 0;
      }
    }
  }
}
</style>
